import apiClient from './apiClient';
import type { EntregaDeEpi, NovaEntregaDeEpi, StatusDaEntregaDeEpi } from '../types/entregaDeEpi';

/** As rotas respondem o corpo direto, sem envelope; aqui ele falha alto se não vier. */
function corpo<T>(resposta: unknown): T {
  if (resposta === undefined || resposta === null) throw new Error('O servidor respondeu sem conteúdo.');
  return resposta as T;
}

class EntregaDeEpiService {
  private base = '/epi-entregas';

  async listar(filtro: {
    employeeId?: number;
    status?: StatusDaEntregaDeEpi;
    pagina: number;
    limite: number;
  }): Promise<{ entregas: EntregaDeEpi[]; total: number }> {
    return corpo(
      await apiClient.get(this.base, {
        params: { employeeId: filtro.employeeId, status: filtro.status, page: filtro.pagina, limit: filtro.limite },
      })
    );
  }

  async detalhar(id: number): Promise<EntregaDeEpi> {
    return corpo(await apiClient.get(`${this.base}/${id}`));
  }

  async registrar(entrada: NovaEntregaDeEpi): Promise<EntregaDeEpi> {
    return corpo(await apiClient.post(this.base, entrada));
  }

  async baixarFicha(id: number, nome: string): Promise<void> {
    const resposta = await apiClient.getClient().get<Blob>(`${this.base}/${id}/ficha`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(resposta.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = nome;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}

export const entregaDeEpiService = new EntregaDeEpiService();
export default entregaDeEpiService;
